import * as z from "zod";

export const StatusSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  color: z.string(),
  order: z.string().default(""),
  icon: z.string().nullable().optional(),
  iconType: z.string().nullable().optional(),
});

export type Status = z.infer<typeof StatusSchema>;

export const StatusInstanceSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  ownerId: z.string(),
  ownerType: z.string(),
  statusId: z.string(),
  status: StatusSchema,
});

export type StatusInstance = z.infer<typeof StatusInstanceSchema>;
